import React from 'react';
import Popup from 'reactjs-popup';

import popupStyles from '../lib/Popup.scss';
import { ComponentWithTr } from '../lib/types';
import styles from './Cmip6ExperimentHelp.scss';

interface ModelsProps {
  models: string[];
}
const Models = ({models}: ModelsProps) => {
  return (
    <div className={styles.models}>
      {models.map(model => (
        <div key={model}>{model}</div>
      ))}
    </div>
  );
};

const Cmip6ExperimentHelp = ({tr}: ComponentWithTr) => {
  return (
    <Popup
      modal
      className="experiment-help"
      trigger={<span className={styles.help}></span>}
      closeOnDocumentClick
    >
      <div>
        <div className={popupStyles.header}>{tr('Ensemble run', 'アンサンブル')}</div>
        <div className={popupStyles.content}>
          <div>
            <p>
              {tr('The ensemble run of each data is either one of:', 'アンサンブルは以下のいずれかとなっています:')}
              <br />
              r1i1p1f1,
              r1i1p1f2,
              r1i1p1f3,
              or
              r1i1p2f1
            </p>
            <p>
              {tr('Refer to the following table for the relation between ensemble run and dataset (model).', 'データセットとアンサンブルとの対応関係は下表の通りです。')}
              <table className={styles.table}>
                <thead>
                  <tr>
                    <th>{tr('Ensemble', 'アンサンブル')}</th>
                    <th>{tr('Dataset', 'データセット')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      r1i1p1f1
                    </td>
                    <td>
                      {'CAMS-CSM1-0/cc10 (except historical)'}
                      <Models
                        models={[
                          'ACCESS-CM2/acm2',
                          'ACCESS-ESM1-5/ac15',
                          'AWI-CM-1-1-MR/ac1m',
                          'AWI-ESM-1-1-LR/ae1m',
                          'BCC-CSM2-MR/bc2m',
                          'BCC-ESM1/bce1',
                          'CAS-ESM2-0/cae2',
                          'CESM2-FV2/ce2f',
                          'CESM2-WACCM-FV2/c2wf',
                          'CIESM/cies',
                          'CMCC-CM2-HR4/cm2h',
                          'CMCC-CM2-SR5/cm2s',
                          'CMCC-ESM2/cme2',
                          'E3SM-1-0/e310',
                          'E3SM-1-1-ECA/e31e',
                          'EC-Earth3-AerChem/e3ac',
                          'EC-Earth3-CC/e3cc',
                          'EC-Earth3-Veg-LR/e3vl',
                          'FGOALS-f3-L/ff3l',
                          'FGOALS-g3/fgg3',
                          'FIO-ESM-2-0/fie2',
                          'GFDL-CM4/gfc4',
                          'GFDL-ESM4/gfe4',
                          'GISS-E2-1-G-CC/ge2c',
                          'IITM-ESM/iiem',
                          'INM-CM4-8/in48',
                          'INM-CM5-0/in50',
                          'IPSL-CM5A2-INCA/ip5i',
                          'IPSL-CM6A-LR-INCA/ip6i',
                          'IPSL-CM6A-LR/ip6l',
                          'KACE-1-0-G/ka1g',
                          'KIOST-ESM/kies',
                          'MIROC6/mrc6',
                          'MPI-ESM-1-2-HAM/mr1a',
                          'MPI-ESM1-2-HR/mr1h',
                          'MPI-ESM1-2-LR/mr1l',
                          'MRI-ESM2-0/mre2',
                          'NESM3/nes3',
                          'NorCPM1/ncp1',
                          'NorESM2-LM/ne2l',
                          'NorESM2-MM/ne2m',
                          'SAM0-UNICON/s0un',
                          'TaiESM1/tes1',
                        ]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      r1i1p1f2
                    </td>
                    <td>
                      {'CAMS-CSM1-0/cc10 (historical only)'}
                      <Models
                        models={[
                          'CNRM-CM6-1-HR/cc6h',
                          'CNRM-ESM2-1/ce21',
                          'GISS-E2-1-H/ge2h',
                          'MCM-UA-1-0/mu10',
                          'MIROC-ES2H/me2h',
                          'MIROC-ES2L/me2l',
                          'UKESM1-0-LL/ue1l',
                        ]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      r1i1p1f3
                    </td>
                    <td>
                      <Models
                        models={[
                          'HadGEM3-GC31-LL/h3gl',
                          'HadGEM3-GC31-MM/h3gm',
                        ]}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      r1i1p2f1
                    </td>
                    <td>
                      <Models
                        models={[
                          'CanESM5-CanOE/ce5o',
                        ]}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </p>
          </div>
        </div>
      </div>
    </Popup>
  );
};

export default Cmip6ExperimentHelp;
